import styled from 'styled-components';
import { Body4Medium } from 'styles/Global/typography';

interface ListProps {
    items: string[];
}

const ListContainer = styled.div`
    display: flex;
    flex-direction: column;
    list-style: disc;
    padding: 16px 16px 16px 12px;
    font-size: 14px;
    gap: 4px;
    border-radius: 12px;
    background-color: white;
`;

export const CertificationList = ({ items }: ListProps) => {
    return (
        <ListContainer>
            {items.map((item, idx) => (
                <Body4Medium key={idx}>• {item}</Body4Medium>
            ))}
        </ListContainer>
    );
};
